module.exports = __webpack_public_path__ + "static/media/bipedge-header.f4892918.webp";